import { render, staticRenderFns } from "./SecondaryPage.vue?vue&type=template&id=0789dea7&scoped=true&"
import script from "./SecondaryPage.vue?vue&type=script&lang=js&"
export * from "./SecondaryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0789dea7",
  null
  
)

export default component.exports